// Plan pricing. USD is the canonical display; IDR is the amount actually charged via Midtrans.
// IDR amounts are integers (Midtrans gross_amount must be an integer in IDR).
export const PLANS = [
  {
    key: "free",
    nameKey: "pricing.free_name",
    pointsKey: "pricing.free_points",
    usd: 0,
    idr: 0,
    perKey: "pricing.per_forever",
    featured: false,
    payable: false,
  },
  {
    key: "growth",
    nameKey: "pricing.growth_name",
    pointsKey: "pricing.growth_points",
    usd: 49,
    idr: 300000,
    perKey: "pricing.per_month",
    featured: true,
    payable: true,
  },
  {
    key: "agency",
    nameKey: "pricing.agency_name",
    pointsKey: "pricing.agency_points",
    usd: 199,
    idr: 2880000,
    perKey: "pricing.per_month",
    featured: false,
    payable: true,
  },
];

// Format a plan price for display. Indonesian locale shows Rupiah, everyone else USD.
export function formatPrice(plan, lang) {
  if (plan.usd === 0) return "$0";
  if (lang === "id") {
    return "Rp" + plan.idr.toLocaleString("id-ID");
  }
  return "$" + plan.usd;
}
